// extracted by mini-css-extract-plugin
export default {"input":"UnicomCode_input__jZdWT","search":"UnicomCode_search__NX7yf"};